import React from "react";
import { Container } from "./styles";
import useCookieDismissable from "../../../hooks/useCookieDismissable";
import { useAppStore } from "../../../stores/appStore";
import classNames from "classnames";

const OverageNotice = ({ subscription }) => {
  const [show, dismiss] = useCookieDismissable("dismiss-overage-notice", 60 * 60 * 24 * 7);

  const isSW2 = useAppStore((state) => state.isSW2);

  if (!subscription || !subscription.usesQuota) return null;

  if (subscription.totalQuota > 0) {
    return null;
  }

  if (!subscription.data.allowOverage) {
    return null;
  }

  if (!show) {
    return null;
  }

  return (
    <Container className={classNames("overage-CTA", { sw2: isSW2 })}>
      <p>
        <strong>Heads up,</strong> you used up all the AI words for your plan, additional words will be billed $0.40 per 1,000 AI words. You can always check your current bill from the settings menu.
      </p>
      <button
        onClick={(e) => {
          e.preventDefault();
          dismiss();
        }}
      >
        Dismiss
      </button>
    </Container>
  );
};

export default OverageNotice;
